
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 14 12","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.136 11.196a.75.75 0 001.061-1.06l-1.06 1.06zM1 6l-.53-.53a.75.75 0 000 1.06L1 6zm5.197-4.136a.75.75 0 00-1.06-1.06l1.06 1.06zM13 6.749a.75.75 0 000-1.5v1.5zm-6.803 3.387L1.53 5.469.47 6.529l4.666 4.667 1.061-1.06zM1.53 6.53l4.667-4.667-1.06-1.06L.47 5.468l1.06 1.06zM1 6.75h12v-1.5H1v1.5z"}})])
          )
        }
      }
    